import { hospitalServices } from "../../Services/HospitalServices/hospital.services";


const hospitalListing = async (params) => {
    let response = await hospitalServices.hospitalList(params);
    if (response && response.status) {
        return response;
    } else {
        return null;
    }
};

const createHospital = async (data) => {
    let post = {
        name: data && data.name ? data.name : null,
        phonenumber: data && data.phonenumber ? data.phonenumber : null,
        email: data && data.email ? data.email : null,
        tag: null,
        gst_number: data && data.gstNumber ? data.gstNumber : null,
        address: data && data.address ? data.address : null,
        city: data && data.city ? data.city.id : null,
        state: data && data.state ? data.state.id : null,
        zipcode: data && data.zipcode ? data.zipcode : null,
        map_link: data && data.mapLink ? data.mapLink : null
    }
    let response = await hospitalServices.createHospital(post);
    if (response) {
        return response;
    } else {
        return null;
    }
};


const hospitalDetail = async (id) => {
    let response = await hospitalServices.hospitalDetail(id);
    if (response && response.status) {
        return response;
    } else {
        return null;
    }
};


const updateHospital = async (data, id) => {
    let post = {
        name: data && data.name ? data.name : null,
        phonenumber: data && data.phonenumber ? data.phonenumber : null,
        email: data && data.email ? data.email : null,
        tag: null,
        gst_number: data && data.gstNumber ? data.gstNumber : null,
        address: data && data.address ? data.address : null,
        city: data && data.city ? data.city.id : null,
        state: data && data.state ? data.state.id : null,
        zipcode: data && data.zipcode ? data.zipcode : null,
        map_link: data && data.mapLink ? data.mapLink : null
    }
    let response = await hospitalServices.updateHospital(post, id);
    if (response) {
        return response;
    } else {
        return null;
    }
};


const deleteHospital = async (id) => {
    let response = await hospitalServices.deleteHospital(id);
    if (response) {
        return response;
    } else {
        return null;
    }
};


const hospitalController = {
    hospitalListing,
    createHospital,
    hospitalDetail,
    updateHospital,
    deleteHospital
};

export default hospitalController;
